import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BroadCastServiceService } from '@shared/services/broad-cast-service.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  subscription: any;
  isComponent: any;

  constructor(private broadCast:BroadCastServiceService,
    private router: Router){}
 
  ngOnInit() {
    this.subscription = this.broadCast
    .getMessage()
    .subscribe((message) => {
      if (message)  {
       this.isComponent=message;
      //  console.log("this.isComponent",this.isComponent)
       
      }
    });
  }
  // onButtonClick(){
  //   this.router.navigate(["/inquiry-form"]);
  // }

}
